import moment from 'moment';

export const getDatesDiffInDays = (from, to = new Date()) =>
  moment(to).diff(moment(from), 'days');

export const isFutureDay = (date) => moment(date).isAfter();

export const isFutureOrCurrentDate = (date, granularity) => {
  const currentDate = moment();
  const isSameGranularity = moment(date).isSame(currentDate, granularity);
  const isAfterDate = isFutureDay(date);

  return isAfterDate || isSameGranularity;
};
